module.exports = __webpack_public_path__ + "static/media/bluesky.3428b55e.svg";